import { createSlice } from '@reduxjs/toolkit';
import { fetchVendorInfoBuilder, signUpBuilder } from './builder';

const initialState = {
  name: '',
  vendorCategory: { name: '', id: null },
  address: '',
  showAddress: true,
  phoneNumber: { value: '', formattedValue: '' },
  instagram: '',
  facebook: '',
  tiktok: '',
  twitter: '',
  links: [],
  banner: null,
  googlePlaceId: '',
  tab: '',
  images: [],
  websiteLink: '',
  disableCategory: false,
  emailToShow: '',
};

export const onboardingSlice = createSlice({
  name: 'onboardingInfo',
  initialState,
  reducers: {
    setOnboardingInfo: (state, { payload }) => (state = { ...state, ...payload }),

    setVendorImages: (state, { payload }) => {
      state.images = [...state.images, ...payload];
    },
  },

  extraReducers: builder => {
    signUpBuilder(builder);
    fetchVendorInfoBuilder(builder);
    builder.addCase('logout', () => initialState);
  },
});

export const { setOnboardingInfo, setVendorImages } = onboardingSlice.actions;

export const selectOnboardingInfo = state => state.onboardingInfo;

export default onboardingSlice.reducer;
